"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
var _EotcBuySellOrderConfirmationModal = _interopRequireDefault(require("../EotcBuySellOrderConfirmationModal"));
var _BuySellTabs = _interopRequireDefault(require("../BuySell/BuySellTabs"));
var _BuySellInstrumentSelector = _interopRequireDefault(require("../BuySell/BuySellInstrumentSelector"));
var _BuySellOrderButton = _interopRequireDefault(require("../BuySell/BuySellOrderButton"));
var _EotcBuySellCustomRow = _interopRequireDefault(require("./EotcBuySellCustomRow"));
var _EotcBuySellPresetValuesRows = _interopRequireDefault(require("./EotcBuySellPresetValuesRows"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('buy-sell');
var EotcBuySell = /*#__PURE__*/function (_React$Component) {
  function EotcBuySell() {
    _classCallCheck(this, EotcBuySell);
    return _callSuper(this, EotcBuySell, arguments);
  }
  _inherits(EotcBuySell, _React$Component);
  return _createClass(EotcBuySell, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        handleSubmit = _this$props.handleSubmit,
        submitting = _this$props.submitting,
        extraInfoComponent = _this$props.extraInfoComponent,
        displayInstrumentSelector = _this$props.displayInstrumentSelector,
        themeModifier = _this$props.themeModifier,
        formHeader = _this$props.formHeader,
        hideKYC = _this$props.hideKYC,
        customKYCmessage = _this$props.customKYCmessage,
        displayExtraInfoComponent = _this$props.displayExtraInfoComponent;
      return /*#__PURE__*/_react["default"].createElement("form", {
        className: baseClasses('container', themeModifier),
        onSubmit: handleSubmit
      }, formHeader && /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('form-header', themeModifier)
      }, formHeader), /*#__PURE__*/_react["default"].createElement(_BuySellTabs["default"], {
        baseClasses: baseClasses,
        themeModifier: themeModifier
      }), displayInstrumentSelector && /*#__PURE__*/_react["default"].createElement(_BuySellInstrumentSelector["default"], {
        baseClasses: baseClasses
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('amount-header', themeModifier)
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Amount"), /*#__PURE__*/_react["default"].createElement("span", null, "Price")), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('amount-container', themeModifier)
      }, /*#__PURE__*/_react["default"].createElement(_EotcBuySellPresetValuesRows["default"], {
        baseClasses: baseClasses
      }), /*#__PURE__*/_react["default"].createElement(_EotcBuySellCustomRow["default"], {
        baseClasses: baseClasses,
        themeModifier: themeModifier
      }), /*#__PURE__*/_react["default"].createElement(_EotcBuySellOrderConfirmationModal["default"], {
        displayPricePerUnit: true
      })), extraInfoComponent && displayExtraInfoComponent && /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('extra-info-container', themeModifier)
      }, extraInfoComponent), /*#__PURE__*/_react["default"].createElement(_BuySellOrderButton["default"], {
        baseClasses: baseClasses,
        handleSubmit: handleSubmit,
        submitting: submitting,
        hideKYC: hideKYC,
        disableKYCLinkUnderReview: true,
        customKYCmessage: customKYCmessage
      }));
    }
  }]);
}(_react["default"].Component);
EotcBuySell.propTypes = {
  handleSubmit: _propTypes["default"].func.isRequired,
  displayInstrumentSelector: _propTypes["default"].bool,
  extraInfoComponent: _propTypes["default"].element,
  themeModifier: _propTypes["default"].string,
  submitting: _propTypes["default"].bool.isRequired,
  hideKYC: _propTypes["default"].bool,
  customKYCmessage: _propTypes["default"].string
};
EotcBuySell.defaultProps = {
  displayInstrumentSelector: true,
  hideKYC: false
};
var _default = exports["default"] = EotcBuySell;